import React from "react";
import { StyledLabel, StyledListItem } from "./setup.style";
import checkedIcon from "../../img/Checked_Icon.svg";
import unCheckedIcon from "../../img/UnChecked_icon.svg";

const ListItem = ({ checked, label, comment }) => {
  return (
    <StyledListItem>
      <img src={checked ? checkedIcon : unCheckedIcon} alt="" />
      <StyledLabel checked={checked}>
        {label} <span>{comment}</span>
      </StyledLabel>
    </StyledListItem>
  );
};
export default ListItem;
